import { VectorSquare } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SchemaIcon = createLucideIcon(VectorSquare);
